<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Head>
          <template v-slot:title>
            <span style="margin-left:30%;">简历-详情</span>
          </template>
        </Head>
      </el-col>
    </el-row>


    <el-row class="row-top" type="flex" justify="center">
      <el-col :span="15">
        <div>
          <el-card class="box-card set-card" style="position:relative;overflow: auto">
            <el-form :label-position="labelPosition" label-width="148px">
              <div class="jllogoBox">
                <div class="logoBox">
                  <div class="logoimg">
                    <el-image v-if="detailData.headPortrait" class="headimg"
                              :src="detailData.headPortrait"
                              :preview-src-list="srcList"
                             
                              >
                    </el-image>
                      <img v-else src="../../../assets/mrtx.png" alt="">
                  </div>
                </div>
                <div class="jsmes">
                  <div class="username">{{ detailData.name }}</div>
                  <div class="conentL">
                    <span style="padding: 0 10px">{{ genderd }}</span>|
<!--                    <span style="padding: 0 10px">{{ detailData.workYearDesc }}</span>|-->
                    <span style="padding: 0 10px">{{ detailData.age }}</span>|
                    <span style="padding: 0 10x">&nbsp;&nbsp;{{ detailData.workYearDesc }}工作经验</span>
                  </div>
                </div>
              </div>
              <el-form-item label="求职状态" style="margin-top: 30px">
                <el-input style="width: 800px" v-model="detailData.applyName" readonly="readonly"
                          class="inp text-bg define-inp"></el-input>
              </el-form-item>
              <el-form-item label="期望行业" style="margin-top: 30px">
                <el-input style="width: 800px" v-model="expectList[0].industryDesc" readonly="readonly"
                          class="inp text-bg define-inp"></el-input>
              </el-form-item>
              <el-form-item label="期望职位" style="margin-top: 30px">
                <el-input style="width: 800px" v-model="expectList[0].positionDesc" readonly="readonly"
                          class="inp text-bg define-inp"></el-input>
              </el-form-item>
              <el-form-item label="居住地" style="margin-top: 30px">
                <el-input style="width: 800px" v-model="detailData.dwell" readonly="readonly"
                          class="inp text-bg define-inp"></el-input>
              </el-form-item>
              <el-form-item label="期望薪资" style="margin-top: 30px">
                <el-input style="width: 100px" v-model="expectList[0].lowSalary" readonly="readonly"
                          class="inp text-bg define-inp"></el-input>
                -
                <el-input style="width: 100px" v-model="expectList[0].highSalary" readonly="readonly"
                          class="inp text-bg define-inp"></el-input>&nbsp;元
              </el-form-item>
              <el-form-item label="工作经历" style="margin-top: 30px">
                <div class="jingliBox inp text-bg define-inp">
                  <div style="padding: 0 20px">
                    <p>公司名称：{{ workExpList[0].companyName }}</p>
                    <p>职位名称：{{ workExpList[0].customPositionName }}</p>
                    <p>所属部门：{{ workExpList[0].department }}</p>
                    <p>开始时间：{{ workExpList[0].startDate }}</p>
                    <p>结束时间：{{ workExpList[0].endDate }}</p>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="工作描述" style="margin-top: 30px">
                <el-input type="textarea" style="width: 800px" v-model="workExpList[0].workContent" readonly="readonly"
                          class="inp text-bg define-inp"></el-input>
              </el-form-item>

              <el-form-item label="附件简历" style="margin-top: 30px">
                <div>
                  <a target="_blank" :href="detailData.url">{{ detailData.accessoryName }}</a>
                </div>
              </el-form-item>
            </el-form>
          </el-card>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Head from '@/components/header/head.vue';
import login from "@/views/login/login";

export default {
  name: "resumedetails",
  components: {
    Head
  },
  data() {
    return {
      labelPosition: 'right',
      detailData: "",
      page: 1,
      size: 1,
      namePas: "",
      switchvalue: false,
      srcListImg: [],
      srcListApprove: [],
      detaillist: "",
      expectList: "",
      srcList: [],

    }
  },
  created() {
   
  },
  mounted() {
    this.Businessdetails()

  },
  methods: {
    // 获取附件简历详情
    Businessdetails(Valid) {
      this.axiosGet('/userResumeAccessory/findAccessoryInfo/' + JSON.parse(this.$route.query.params), {}).then((res) => {
        if (res.code == 200) {
          this.detailData = res.data
       
          this.srcList.push(res.data.headPortrait)
          this.expectList = res.data.expectList // 简历期望
          this.workExpList = res.data.workExpList // 用户简历
          console.log(this.expectList);
          if (this.detailData.gender == 1) {
            this.genderd = '男'
          } else {
            this.genderd = '女'
          }
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.define-inp .el-input__inner, .define-inp .el-textarea__inner {
  width: 800px !important;
}

.jllogoBox {
  width: 85%;
  height: 90px;
  padding-left: 65px;
  display: flex;

  .logoBox {
    width: 90px;
    height: 90px;
    //background-color: blue;
    display: flex;
    justify-content: center;
    align-items: center;
  

    .logoimg {
      width: 75px;
      height: 73px;
      background-color: #FFFFFF;
      border-radius: 50px;

      .headimg {
        width: 75px;
        height: 73px;
        //border-radius: 50px;
        border-radius: 50px;
      }
    }
  }

  .jsmes {
    .username {
      padding-left: 10px;
      margin-top: 10px;
      height: 40px;
      line-height: 40px;
    }

    .conentL {
      height: 40px;
      line-height: 40px;
    }
  }

}

.jingliBox {
  width: 800px;
  //height: 200px;
  background-color: #EEF2FB;
  border-radius: 5px;
}

</style>
